/**
 * Sync Log Service
 *
 * API client for sync log endpoints.
 * Fetches sync history for bank connections.
 */

import { fetchApi } from '@/shared/services';
import type { PaginatedResponse, SyncLogWithConnection } from '@/shared/types';

export interface SyncLogParams {
  connection_id?: string;
  status?: string;
  page?: number;
  page_size?: number;
}

export const syncLogService = {
  /**
   * List sync logs, optionally filtered by connection and status.
   */
  list: (params?: SyncLogParams) => {
    const searchParams = new URLSearchParams();
    if (params?.connection_id) searchParams.set('connection_id', params.connection_id);
    if (params?.status) searchParams.set('status', params.status);
    if (params?.page) searchParams.set('page', String(params.page));
    if (params?.page_size) searchParams.set('page_size', String(params.page_size));
    const qs = searchParams.toString();
    return fetchApi<PaginatedResponse<SyncLogWithConnection>>(`/sync-logs${qs ? `?${qs}` : ''}`);
  },
};
